module.exports = __webpack_public_path__ + "static/media/04.57c9b770.jpg";